module.exports = __webpack_public_path__ + "media/images/icons/signpost-0fd2b34ed139be527f1d4a9ce2e4d6d7.svg";